<template>
  <div class="bg" :style="{backgroundImage:bgImg}">
    <div v-if="$route.meta.fullPage" style="height: 100%">
      <div style="background-color: #fff">
        <div class="w1180">
        <el-row type="flex" align="middle" justify="space-around">
          <el-col :span="15">
            <div style="display: flex;flex-direction: row;flex-wrap: nowrap;align-content: center">
              <el-image src="https://www.huayitraveltd.com/img/logo.png" fit="contain" style="width: 200px" v-if="true" />
              <el-image src="https://www.huayitraveltd.com/weblogo.png" fit="contain" style="width: 200px" v-else />
              <el-menu :default-active="activeIndex" ref="hdMenu" class="headerMenu" mode="horizontal" router style="margin-left: 15px" >
                <el-menu-item index="Index" route="/">{{ $t("header.index") }}</el-menu-item>
                <el-menu-item index="HotelList" route="/hotel/list">{{ $t("header.hotel") }}</el-menu-item>
                <el-menu-item index="TicketList" route="/ticket/list">{{ $t("header.ticket") }}</el-menu-item>
                <el-menu-item index="TourList" route="/tour/list">{{ $t("header.tour") }}</el-menu-item>
                <el-menu-item index="DomesticList" route="/domestic/list" v-if="false">{{ $t("header.gntp") }}</el-menu-item>
                <el-menu-item index="CruiseList" route="/cruise/list">{{ $t("header.yl") }}</el-menu-item>
              </el-menu>
            </div>
          </el-col>
          <el-col :span="9">
            <div style="display: flex;flex-direction: row;flex-wrap: nowrap;align-items: center;justify-content: end;">
              <el-dropdown @command="handleLangChange" size="medium" style="margin-right: 15px;cursor: pointer">
              <span class="el-dropdown-link">
              {{lang}}<i class="el-icon-arrow-down el-icon--right" />
              </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="zhCN">简体</el-dropdown-item>
                  <el-dropdown-item command="zhHK">繁體</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-dropdown size="medium" style="margin-right: 15px;cursor: pointer" @command="handleCurrencyChange">
              <span class="el-dropdown-link" >
              {{$t('util.bz')}}:{{Vcurrency}}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
                <el-dropdown-menu slot="dropdown" >
                  <el-dropdown-item v-for="(val,key) in currencyList" :key="key" :command="val" :disabled="VuserType === 'B2B' && val !== Vcurrency">{{val}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-popover
                placement="bottom"
                title=""
                width="200"
                trigger="hover"
                style="margin-right: 15px;cursor: pointer"
              >
                <el-image src="https://www.huayitraveltd.com/img/contact-box.jpg" fit="contain" style="width: 220px"/>
                <div slot="reference" style="font-size: 14px">
                  <i class="el-icon-phone-outline" ></i>{{$t('util.llwm')}}
                </div>
              </el-popover>
              <el-divider direction="vertical" ></el-divider>
              <usr-box ref="UserBox"/>
            </div>
          </el-col>
        </el-row>
        </div>
      </div>
      <slot />
      <div style="background-color: #fff;height: auto;box-sizing: border-box;padding:25px 0;border-top: solid 1px #eeeeee;">
        <div class="w1180">
          <el-row justify="space-between" align="middle" type="flex">
            <el-col :span="12">
              <el-image fit="contain" style="width: 400px" src="https://www.huayitraveltd.com/img/color.logo.png" />
            </el-col>
            <el-col :span="12">
              <el-row type="flex" justify="end" class="footMenu">
                <el-col :span="8">
                  <label>HUAYI TRAVEL</label>
                  <ul>
                    <li><router-link to="/article/2">{{$t('util.gywm')}}</router-link></li>
                    <li><router-link to="/article/3">{{$t('util.tkxz')}}</router-link></li>
                    <li><a href="https://tour.huayitraveltd.com/appDown/#/" target="_blank">{{$t('util.mee')}}</a></li>
                    <li><a href="https://image.huayitraveltd.com/HongKongHuayiTravelDistributionCooperationAgreement.pdf" target="_blank">{{$t('util.Agreement')}}</a></li>
                  </ul>
                </el-col>
                <el-col :span="8">
                  <label >{{$t('util.lxwm')}}</label>
                  <ul>
                    <li><router-link to="/article/26">{{$t('util.khfwzy')}}</router-link></li>
                    <li><router-link to="/article/32">{{$t('util.jrwm')}}</router-link></li>
                  </ul>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </div>
      <el-row type="flex" align="middle" justify="center" class="foot">
        <el-col :span="24">CopyRight©2010~2023 huayitraveltd.com {{$t('util.bqsy')}}  |  <a href="http://beian.miit.gov.cn/" target="_blank">粤ICP备19153240号-1</a></el-col>
      </el-row>
    </div>
    <slot v-else />
    <el-backtop :bottom="130">
      <div
        style="{
        height: 100%;
        width: 100%;
        text-align: center;
        color: #1989fa;
      }"
      ><i class="el-icon-top" /></div>
    </el-backtop>
    <el-backtop :bottom="80" >
      <div
        @click.stop="handleDownApp"
        style="{
        height: 100%;
        width: 100%;
        font-size: 14px;
        text-align: center;
        color: #1989fa;
      }"
      >APP</div>
    </el-backtop>
  </div>
</template>

<script>
import {currencyList} from '../../service/util'
import UsrBox from './usrBox'
var ctx
export default {
  name: 'hy-layout',
  components: {UsrBox},
  data () {
    return {
      bgImg: '',
      activeIndex: 'Index',
      currencyList: []
    }
  },
  watch: {
    '$route.path': {
      handler (v) {
        console.log(v)
        if (v) {
          let rootPath = v.split('/')
          if (rootPath.length >= 2) {
            rootPath = rootPath[1]
            let activeIndex = ''
            if (rootPath === '') {
              activeIndex = 'Index'
            } else if (rootPath === 'hotel') {
              activeIndex = 'HotelList'
            } else if (rootPath === 'ticket') {
              activeIndex = 'TicketList'
            } else if (rootPath === 'tour') {
              activeIndex = 'TourList'
            } else if (rootPath === 'cruise') {
              activeIndex = 'CruiseList'
            } else if (rootPath === 'domestic') {
              activeIndex = 'DomesticList'
            }
            this.activeIndex = activeIndex
          } else {
            rootPath = ''
          }
          console.log(this.activeIndex)
        }
      },
      immediate: true
    }
  },
  created () {
    this.$EventBus.$on('loginRequest', this.requestLogin)
  },
  mounted () {
    this.refReady('hdMenu').then(ref => {
      ref.activeIndex = this.activeIndex
    })

    currencyList().then(res => {
      if (res.code === 200) {
        this.currencyList = res.data
      }
    })
    if (this.VuserType === 'B2B') {
      if (this.Vcurrency !== this.VcompanyInfo.currency) {
        this.handleCurrencyChange(this.VcompanyInfo.currency)
      }
    }
  },
  destroyed () {
    if (ctx) clearTimeout(ctx)
    this.$EventBus.$off('loginRequest')
  },
  computed: {
    lang () {
      return this.$i18n.locale === 'zhCN' ? '简体' : '繁體'
    }
  },
  methods: {
    refReady (ref) {
      if (ctx) clearTimeout(ctx)
      return new Promise(resolve => {
        if (typeof this.$refs[ref] !== 'undefined') {
          resolve(this.$refs[ref])
        } else {
          ctx = setTimeout(() => {
            return this.refReady(ref)
          }, 10)
        }
      })
    },
    requestLogin () {
      this.$refs.UserBox.fnHandleLogin()
    },
    handleLangChange (e) {
      this.setLang(e)
      this.$i18n.locale = e
    },
    handleCurrencyChange (e) {
      this.setCurrency(e)
      window.location.reload(-1)
    },
    handleDownApp () {
      window.location.href = 'https://tour.huayitraveltd.com/appDown/#/'
    }
  }
}
</script>
<style>
.el-backtop{
  z-index: 12;
}
</style>
<style scoped lang="scss">
.foot{
  background: #1a1a1a;
  color: #fff;
  & a{
    color: #fff;
  }
}
.bg{
  display: inline-block;
  height: 100%;
  width: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.footMenu{
  & label{
    font-size: 16px;
    font-weight: bolder;
  }
  & p{
    margin:5px 0;
    font-size: 14px;
    color: #2e2e2e;
  }
  & ul,
  & ul li{
    list-style: none;
    margin:0;
    padding: 0;
  }
  & ul li{
    font-size: 14px;
    margin: 5px 0 5px 8px;
    & a:hover{
      text-decoration: underline !important;
    }
    & a{
      cursor: pointer;
      color: #3264ff;
      text-decoration: none;
    }
  }
}
.headerMenu{
  border-bottom: none !important;

  & .el-menu-item{
    font-size: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/global/hy-layout.vue